import { apiClient, handleResp } from './utils';
export default {
  doAddLocation(data) {
    return handleResp(apiClient().post('/add_location', data));
  },
  doUpdateLocation(data) {
    return handleResp(apiClient().post('/update_location', data));
  },
  getMyLocations() {
    return handleResp(apiClient().get('/my_locations'));
  },
  getNearby(query) {
    return handleResp(apiClient().post('/nearby_locations', { query }));
  },
};
